window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.form-toggle-section').length) {
    import('./_forms.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}